import * as React from 'react';

interface FileAudioIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Extensão exibida na etiqueta (`MP3`, `WAV`, `OGG`…).
   *
   * Aqui o rótulo é `<text>`, e não glifos desenhados como no resto da
   * família: um único componente cobre todos os formatos de áudio, em vez de
   * exigir um arquivo novo (e um alfabeto novo) a cada extensão que aparecer.
   * A lista de anexos já imprime a extensão ao lado do ícone, então a etiqueta
   * é reforço, não a única pista.
   */
  extension?: string;
}

/**
 * Ícone de arquivo de áudio.
 *
 * Mesma silhueta de documento e mesma etiqueta da família em
 * `Icons/Attachments`, com a nota musical no lugar das linhas de texto e a cor
 * âmbar, que nenhum outro tipo usa.
 */
export const FileAudioIcon = ({
  extension = 'MP3',
  ...props
}: FileAudioIconProps) => (
  <svg
    width="35"
    height="45"
    viewBox="0 0 35 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M29.0979 10.2604C27.9589 10.2593 26.8669 9.80634 26.0615 9.00096C25.2562 8.19557 24.8032 7.10355 24.8021 5.96456V0H5.60627C2.51003 0 1.60933e-05 2.51 1.60933e-05 5.60623V39.4021C0.00461092 42.4932 2.5151 45 5.60627 45H28.6479C29.3843 45.0003 30.7292 45 30.7292 45H32.5C33.47 45 34.2563 44.2144 34.2563 43.2444C34.2563 41.7705 34.2563 39.8362 34.2563 39.3938V10.2521L29.0979 10.2604Z"
        fill="#E3A008"
      />
    </g>
    <path
      d="M34.2566 10.2604H29.0983C27.9593 10.2593 26.8673 9.80634 26.0619 9.00096C25.2565 8.19557 24.8035 7.10355 24.8024 5.96456V0L34.2566 10.2604Z"
      fill="#E3A008"
    />

    {/* Moldura do corpo: o mesmo retângulo arredondado dos outros ícones da
        família, sem as três linhas de texto que eles desenham dentro. */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7181 15.6459V29.353C10.73 29.362 10.7547 29.3745 10.793 29.3745H23.3747C23.4131 29.3745 23.4378 29.362 23.4496 29.353V15.6459C23.4378 15.6369 23.4131 15.6245 23.3747 15.6245H10.793C10.7547 15.6245 10.73 15.6369 10.7181 15.6459ZM9.19037 15.6245C9.19037 14.715 9.97671 14.0967 10.793 14.0967H23.3747C24.1911 14.0967 24.9774 14.715 24.9774 15.6245V29.3745C24.9774 30.2839 24.1911 30.9022 23.3747 30.9022H10.793C9.97671 30.9022 9.19037 30.2839 9.19037 29.3745V15.6245Z"
      fill="#E3A008"
    />

    {/* Nota musical: haste, bandeira e a cabeça inclinada. */}
    <path d="M18.05 17.85H19.2V25.45H18.05V17.85Z" fill="#E3A008" />
    <path
      d="M19.2 17.85C20.95 18.35 22.05 19.45 22.05 21.05C22.05 21.75 21.85 22.35 21.45 22.85C21.65 21.15 20.6 20.05 19.2 19.55V17.85Z"
      fill="#E3A008"
    />
    <ellipse
      cx="16.35"
      cy="25.35"
      rx="2.45"
      ry="1.95"
      transform="rotate(-18 16.35 25.35)"
      fill="#E3A008"
    />

    <rect
      x="6.98016"
      y="33.203"
      width="20.8333"
      height="7.62962"
      rx="1.5625"
      fill="#E3A008"
    />
    <text
      x="17.3968"
      y="38.42"
      textAnchor="middle"
      dominantBaseline="middle"
      fill="white"
      fontFamily="system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
      fontSize="5.4"
      fontWeight="600"
      letterSpacing="0.1"
    >
      {`.${extension}`}
    </text>
  </svg>
);

export default FileAudioIcon;
